<template>
  <div class="work-order">
    <div class="top">
      <div>
        <el-button
          type="primary"
          class="iss-operation-button"
          style="padding: 7px 7px"
          icon="iconfont icon-iconfontfanhui"
          @click="$router.go(-1)"
          >返回</el-button
        >
      </div>
      <div>
        {{ $route.query.name }}
      </div>
      <div>
        <el-button
          v-if="authList.indexOf('workOrder:setWorkOrderRight') != -1"
          type="primary"
          class="iss-operation-button"
          icon="el-icon-setting"
          style="padding: 7px 7px"
          @click="appendSet"
          >权限设置</el-button
        >
      </div>
    </div>
    <div class="template-list card-list" style="display: flex">
      <el-scrollbar
        class="full-width"
        style="height: calc(100% - 70px)"
        v-loading="loadingTable"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-row>
          <el-col
            class="template-item"
            :span="3"
            v-for="(temp, index) in templateList"
            :key="index"
            :offset="index % 6 > 0 ? 1 : 0"
          >
            <el-card
              :body-style="{ padding: '0px', margin: '10px' }"
              shadow="hover"
            >
              <div class="template-card card" @click="openWorkOrder(temp)">
                <span class="title">{{ temp.templateName }}</span>
                <img
                  :src="imgPath(temp.fileCode)"
                  class="image mt10"
                  onerror="this.src='/images/theme/newDark/default.png'"
                />
                <div class="clearfix">
                  <el-button
                    type="text"
                    @click.stop="editTemp(temp)"
                    class="button"
                    v-if="
                      authList.indexOf('workOrder:updateWorkOrderTemplate') !=
                      -1
                    "
                    >编辑</el-button
                  >
                  <el-button
                    type="text"
                    @click.stop="deleteTemp(temp)"
                    class="button"
                    v-if="
                      authList.indexOf('workOrder:deleteWorkOrderTemplate') !=
                      -1
                    "
                    >删除</el-button
                  >
                  <!-- <i class="edit-button iconfont icon-xiugai"
                     @click.stop="editTemp(temp)"></i>
                  <i class="edit-button iconfont icon-shanchu"
                     @click.stop="deleteTemp(temp)"></i> -->
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col
            class="template-item"
            :span="3"
            :offset="1"
            v-if="authList.indexOf('workOrder:addWorkOrderTemplate') != -1"
          >
            <el-card
              :body-style="{ padding: '0px', margin: '10px' }"
              shadow="hover"
            >
              <div class="template-card card" @click="addTemp">
                <div class="add iconfont-lunan icon-lunan-jia-copy" />
                <span class="title create">{{
                  $t("workOrder.title.create")
                }}</span>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-scrollbar>
      <!-- <div class="pagination">
        <el-pagination
          class="mt30 mb20"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :page-size="page.pageSize"
          :total="page.total"
          :current-page="page.currentPage"
          @size-change="sizeChange"
          @current-change="pageChange"
          @prev-click="pageChange"
          @next-click="pageChange"
        />
      </div>-->
    </div>
    <el-dialog
      width="400px"
      :visible.sync="showDialog"
      v-dialogDrag
      :title="
        showType === 'add'
          ? $t('workOrder.button.add')
          : $t('workOrder.button.edit')
      "
      :before-close="closeDialog"
    >
      <el-form
        ref="form"
        :model="templateInfo"
        label-width="85px"
        :rules="rules"
      >
        <el-form-item
          prop="templateName"
          :label="$t('workOrder.label.templateName')"
        >
          <el-input
            :placeholder="$t('workOrder.placeholder.templateName')"
            v-model="templateInfo.templateName"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="workOrderType"
          :label="$t('workOrder.label.workOrderType')"
        >
          <el-select
            v-model="templateInfo.workOrderType"
            :disabled="showType === 'edit'"
            style="width: 100%"
            filterable
            ref="elSelect"
            allow-create
            @change="typeChange"
            default-first-option
            :placeholder="$t('workOrder.placeholder.workOrderType')"
          >
            <el-option
              v-for="(item, i) in workorderTypes"
              :key="i"
              :label="item.workOrderTypeName"
              :value="item.workOrderTypeCode"
            >
              <span class="leftBtn">{{ item.workOrderTypeName }} </span>
              <!-- <el-input @click.stop="editClick"
                        style="float: left;width:60%"
                        v-model="item.label"> </el-input> -->
              <div class="rightBtn" v-if="item.workOrderTypeCode > 5">
                <span @click.stop="editClick(item)" style="margin-right: 5px"
                  >编辑</span
                >
                <span @click.stop="delClick(item.workOrderTypeCode)">删除</span>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('workOrder.label.fileUpload')" prop="fileList">
          <div
            class="image-item"
            v-if="templateInfo.fileList && templateInfo.fileList.length"
          >
            <img
              :src="templateInfo.fileList[0].url"
              class="image-file"
              onerror="this.src='/images/theme/newDark/default.png'"
            />
            <div class="delete-icon">
              <i class="el-icon-delete" @click="onRemove"></i>
            </div>
          </div>
          <div
            v-show="!(templateInfo.fileList && templateInfo.fileList.length)"
          >
            <el-upload
              action
              :file-list="templateInfo.fileList"
              ref="addRosterUl"
              :show-file-list="false"
              :list-type="'picture-card'"
              accept="image/png, image/jpg, image/jpeg, image/bpm"
              :auto-upload="false"
              :multiple="false"
              :limit="1"
              :on-change="onChange"
              :on-remove="onRemove"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="closeDialog()">{{
          $t("workOrder.button.cancel")
        }}</el-button>
        <el-button type="primary" @click="saveForm()">{{
          $t("workOrder.button.save")
        }}</el-button>
      </div>
    </el-dialog>
    <!--权限设置 弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="460px"
      :before-close="
        () => {
          dialogVisible = false;
        }
      "
    >
      <div>
        <!-- dialogTop -->
        <div class="dialogTop">
          <div class="tColor">全部成员</div>
          <div>
            <el-button
              type="primary"
              class="iss-operation-button"
              icon="el-icon-s-check"
              style="padding: 7px 7px"
              @click="addPeoPle"
              >添加保卫成员</el-button
            >
          </div>
        </div>
        <div class="dialogMain">
          <!-- 管理员 -->
          <div>
            <div class="tColor">管理员</div>
            <el-scrollbar style="height: 140px">
              <div class="listM">
                <div
                  class="listItem"
                  v-for="(item, index) in listManage.filter((el) => {
                    return el.personType == 1;
                  })"
                  :key="index"
                >
                  <img
                    :src="imgPath(item.fileCode)"
                    class="listImg"
                    onerror="this.src='/images/theme/newDark/default.png'"
                  />
                  <span class="listSpan">{{ item.nickName }}</span>
                </div>
                <div style="margin: 0 auto" v-if="!listManage.length">
                  <img
                    src="@/common/assets/images/empty.svg"
                    class="no-data_img"
                  />
                  <div>暂无数据</div>
                </div>
              </div>
            </el-scrollbar>
            <div
              class="tColor"
              style="
                margin-top: 20px;
                padding-bottom: 10px;
                border-bottom: 1px solid rgba(225, 225, 230, 1);
              "
            >
              普通用户
            </div>
            <el-scrollbar style="height: 140px">
              <div class="listM">
                <div
                  class="listItem"
                  v-for="(item, index) in listManage.filter((el) => {
                    return el.personType == 2;
                  })"
                  :key="index"
                >
                  <img
                    :src="imgPath(item.fileCode)"
                    class="listImg"
                    onerror="this.src='/images/theme/newDark/default.png'"
                  />
                  <span class="listSpan">{{ item.nickName }}</span>
                </div>
                <div style="margin: 0 auto" v-if="!listManage.length">
                  <img
                    src="@/common/assets/images/empty.svg"
                    class="no-data_img"
                  />
                  <div>暂无数据</div>
                </div>
              </div>
            </el-scrollbar>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 修改类型名称 -->
    <el-dialog
      title="设置类型名称"
      :visible.sync="dialogType"
      width="300px"
      :before-close="
        () => {
          dialogType = false;
        }
      "
    >
      <el-form
        ref="formType"
        :rules="rules"
        :model="formType"
        label-width="110px"
      >
        <el-form-item label="原类型名称：">
          <span>{{ formType.workOrderTypeName }}</span>
        </el-form-item>
        <el-form-item label="新类型名称：" prop="name">
          <el-input v-model="formType.name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateType" type="primary">确 认</el-button>
        <el-button @click="dialogType = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 安保人员-->
    <person-transfer
      ref="transfer"
      :setData="setData"
      @refreshData="getPeopleList()"
    ></person-transfer>
    <!-- 工作组 -->
    <!-- <work-group-tree ref="transfer"
                     :multiCheck="true"
                     @groupData="getGroupData"
                     :showPercentage="false"></work-group-tree> -->
  </div>
</template>
<script>
import { api } from "../api";
import { Dic, Bus, Dates } from "$utils";
import utils from "@src/common/utils";
import personTransfer from "../components/person-transfer";
import workGroupTree from "../components/workGroupTree";
export default {
  components: { personTransfer },
  data() {
    return {
      setData: {
        title: "选择人员",
        leftTitle: "人员列表",
        rightTitle: "已选择人员",
        showSelect: true,
        code: "",
      },
      listManage: [],
      treeForm: {
        name: "",
      },
      templateList: [],
      templateInfo: {
        templateCode: "",
        templateName: "",
        workOrderType: "",
        fileList: [],
        fileCode: "",
      },
      workorderTypes: [] || Dic.find("SENU082"),
      rules: {
        templateName: [
          {
            required: true,
            message: this.$t("workOrder.placeholder.templateName"),
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入名称",
            trigger: "change",
          },
        ],
        workOrderType: [
          {
            required: true,
            message: this.$t("workOrder.placeholder.workOrderType"),
            trigger: "change",
          },
        ],
        // fileList: [
        //   {
        //     required: true,
        //     message: this.$t("workOrder.placeholder.fileUpload"),
        //     trigger: "blur",
        //   },
        // ],
      },
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      title: "",
      showType: "add",
      showDialog: false,
      // 迭代数据
      treeData: [],
      searchString: "",
      expandedKeys: [],
      workGroupCode: "",
      dialogVisible: false,
      dialogTitle: "",
      loadingTable: false,
      checkData: {},
      workOrderWorkGroupCode: "",
      dialogType: false,
      authList: [],
      formType: {
        name: "",
        workOrderTypeName: "",
        workOrderTypeCode: "",
      },
      treeProps: {
        children: "children",
        label: "name",
        isLeaf: "isLeaf",
      },
    };
  },
  watch: {
    searchString(val) {
      this.$refs.tree.filter(val);
    },
  },
  created() {
    this.workOrderWorkGroupCode = this.$route.query.id;
    this.setData.code = this.$route.query.id;
    this.queryTemplateList();
    this.getTypeList();
    this.queryWorkOrderAuthGroup();
  },
  mounted() {},
  methods: {
    queryWorkOrderAuthGroup() {
      this.authList = [];
      this.$fetch(api.workOrder.queryWorkOrderAuthGroup, {
        workOrderWorkGroupCode: this.workOrderWorkGroupCode,
      }).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
        } else {
          this.authList = response.returnObj;
        }
      });
    },
    updateType() {
      this.$refs.formType.validate((valid) => {
        if (valid) {
          this.$fetch(api.workOrder.updateWorkOrderType, {
            workOrderTypeCode: this.formType.workOrderTypeCode,
            workOrderTypeName: this.formType.name,
          }).then((response) => {
            if (!response.success) {
              this.$message.error(response.msgContent);
            } else {
              this.dialogType = false;
              this.getTypeList();
            }
          });
        }
      });
    },
    getTypeList(iSshow = false) {
      this.$fetch(api.workOrder.queryWorkOrderType).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
        } else {
          this.workorderTypes = response.returnObj || [];
          this.$nextTick(() => {
            if (iSshow == true) {
              this.templateInfo.workOrderType =
                this.workorderTypes[
                  this.workorderTypes.length - 1
                ].workOrderTypeCode;
            }
          });
        }
      });
    },
    typeChange(val) {
      if (isNaN(val)) {
        // 新增数据
        this.addWorkOrderType(val);
      }
    },
    addWorkOrderType(val) {
      this.$fetch(api.workOrder.addWorkOrderType, {
        workOrderTypeName: val,
      }).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
        } else {
          this.getTypeList(true);
        }
      });
    },
    delClick(code) {
      this.$fetch(api.workOrder.delWorkOrderType, {
        workOrderTypeCodeList: [code],
      }).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
        } else {
          if (code == this.templateInfo.workOrderType) {
            this.templateInfo.workOrderType = "";
          }
          // this.$refs.elSelect.blur()
          this.getTypeList();
        }
      });
      // this.gridData.splice(index, 1);
    },
    editClick(item) {
      this.dialogType = true;
      this.formType.name = "";
      this.formType.workOrderTypeCode = item.workOrderTypeCode;
      this.formType.workOrderTypeName = item.workOrderTypeName;
      this.$refs.elSelect.blur();
    },
    getPeopleList() {
      let params = {
        workOrderRelationCode: this.workOrderWorkGroupCode,
        workOrderRightType: "1",
      };
      this.$fetch(api.workOrder.getWorkerList, params).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
        } else {
          let result = response.returnObj
            ? response.returnObj.workOrderRightPersonList
            : [];
          this.listManage = [...result];
        }
      });
    },
    addPeoPle() {
      this.$refs.transfer.open();
    },
    appendSet() {
      this.dialogTitle = "权限设置";
      this.dialogVisible = true;
      this.getPeopleList();
      this.treeForm.name = "";
    },
    removeArea(node, data) {
      this.$confirm("您确定删除该工作组及下属工作组么?", "确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          workOrderWorkGroupCode: this.workOrderWorkGroupCode,
        };
        this.$fetch(api.workOrder.deleteWorkOrderWorkGroup, params).then(
          (response) => {
            if (!response.success) {
              this.$message.error(response.msgContent);
            } else {
              this.$message.success("删除成功");
              this.queryTemplateList();
            }
          }
        );
      });
    },
    imgPath(fileCode) {
      return fileCode
        ? utils.Bus.imgPath(fileCode)
        : "/images/theme/newDark/default.png";
    },
    saveForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.templateInfo.fileCode) {
            this.saveTemplateInfo(this.templateInfo.fileCode);
            return false;
          }
          let formData = new FormData();
          this.templateInfo.fileList.map((item) => {
            formData.append("files", item.raw);
          });
          let picUrl = [];
          let pictur = "";
          this.$fetch(api.workOrder.upFile, formData).then((res) => {
            if (res.success) {
              res.returnObj.forEach((item) => {
                picUrl.push(item.fileId);
              });
              pictur = picUrl.join(",");
              this.saveTemplateInfo(pictur);
            } else {
              this.$message.error(res.msgContent);
            }
          });
        } else {
          return false;
        }
      });
    },
    saveTemplateInfo(pictur) {
      if (this.showType === "edit") {
        let param = {
          templateCode: this.templateInfo.templateCode,
          templateName: this.templateInfo.templateName,
          workOrderType: this.templateInfo.workOrderType,
          fileCode: pictur,
        };
        this.$fetch(api.workOrder.updateWorkOrderTemplate, param).then(
          (res) => {
            if (res.success) {
              this.closeDialog();
              this.queryTemplateList();
            } else {
              this.$message.error(res.msgContent);
            }
          }
        );
      } else {
        let param = {
          templateName: this.templateInfo.templateName,
          workOrderType: this.templateInfo.workOrderType,
          fileCode: pictur,
          workOrderWorkGroupCode: this.workOrderWorkGroupCode,
        };
        this.$fetch(api.workOrder.addWorkOrderTemplate, param).then((res) => {
          if (res.success) {
            this.closeDialog();
            this.queryTemplateList();
          } else {
            this.$message.error(res.msgContent);
          }
        });
      }
    },
    queryTemplateList() {
      this.loadingTable = true;
      this.$fetch(api.workOrder.queryWorkOrderTemplateList, {
        workOrderWorkGroupCode: this.workOrderWorkGroupCode,
      }).then((res) => {
        setTimeout(() => {
          this.loadingTable = false;
        }, 500);
        if (res.success) {
          this.templateList = res.returnObj;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    clearForm() {
      this.templateInfo = {
        templateCode: "",
        templateName: "",
        workOrderType: "",
        fileList: [],
        fileCode: "",
      };
      this.$refs.form.resetFields();
    },
    closeDialog(callback) {
      this.clearForm();
      if (callback && typeof callback === "function") {
        callback();
      } else {
        this.showDialog = false;
      }
    },
    openWorkOrder(row) {
      this.$router.push({
        path: "/workorder/list",
        query: {
          templateCode: row.templateCode,
          templateName: row.templateName,
          workOrderType: row.workOrderType,
          executorFlag: row.executorFlag, //是否有执行人
          workFlowFlag: row.workFlowFlag, //是否有工作流
        },
      });
    },
    addTemp() {
      this.showType = "add";
      this.templateInfo.workOrderType = "5"; //默认
      this.showDialog = true;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.queryTemplateList();
    },
    pageChange(currentPage) {
      this.page.currentPage = currentPage;
      this.queryTemplateList();
    },
    editTemp(row) {
      console.log(row);
      this.showType = "edit";
      this.templateInfo.templateCode = row.templateCode;
      this.templateInfo.templateName = row.templateName;
      this.templateInfo.workOrderType = row.workOrderType;
      if (row.fileCode) {
        this.templateInfo.fileList = [{ url: utils.Bus.imgPath(row.fileCode) }];
        this.templateInfo.fileCode = row.fileCode;
      }
      this.showDialog = true;
    },
    deleteTemp(row) {
      this.$confirm(
        this.$t("workOrder.message.deltips"),
        this.$t("workOrder.title.warn"),
        {
          confirmButtonText: this.$t("workOrder.button.confirm"),
          cancelButtonText: this.$t("workOrder.button.cancel"),
          type: "warning",
        }
      ).then(() => {
        this.$fetch(api.workOrder.deleteWorkOrderTemplate, {
          templateCode: row.templateCode,
        }).then((res) => {
          if (res.success) {
            this.queryTemplateList();
          } else {
            this.$message.error(res.msgContent);
          }
        });
      });
    },
    validImg(file) {
      const fileName = file.name;
      const type = fileName.slice(fileName.indexOf(".") + 1, fileName.length);
      const imgArr = ["jpg", "png", "jpeg", "bpm", "JPG", "PNG", "JPEG", "BPM"];
      let isJPG = null;
      imgArr.indexOf(type) === -1 ? (isJPG = false) : (isJPG = true);
      if (!isJPG) {
        this.$message.error(this.$t("videoPatrol.message.sizePicture"));
        return false;
      }
      return true;
    },
    onChange(file, fileList) {
      if (!this.validImg(file)) {
        this.deleteImg(file, fileList);
        return false;
      }
      this.templateInfo.fileCode = "";
      this.$set(this.templateInfo, "fileList", fileList);
    },
    deleteImg(file, fileList) {
      let index = this.templateInfo.fileList.findIndex((item) => {
        return item.url === file.url;
      });
      this.templateInfo.fileCode = "";
      fileList.splice(index, 1);
    },
    onRemove(file, fileList) {
      this.$confirm("确认要删除图片吗？", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.templateInfo.fileCode = "";
        this.$set(this.templateInfo, "fileList", []);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.rightBtn {
  display: none;
  @include set_theme_color(color, main-theme-color);
}
.el-select-dropdown__item {
  &:hover {
    .rightBtn {
      float: right;
      font-size: 13px;
      display: block !important;
    }
  }
}
.work-order {
  height: 100%;
  width: 100%;
  position: absolute;
  padding: 20px;
  .dialogTop {
    flex-direction: row;
    justify-content: space-between;
    display: flex;
    padding-bottom: 10px;
    margin-bottom: 10px;
    border-bottom: 1px solid rgba(225, 225, 230, 1);
  }
  .dialogMain {
    .tColor {
      color: rgba(245, 245, 245, 1);
    }

    .listM {
      flex-wrap: wrap;
      display: flex;
      margin: 15px 0;
      .listItem {
        margin-right: 20px;
        margin-bottom: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        .listSpan {
          display: inline;
          width: 80px;
        }
        .listImg {
          width: 24px;
          height: 24px;
          margin-right: 10px;
          border-radius: 10px;
        }
      }
    }
  }
  .top {
    padding: 0 10px;
    flex-direction: row;
    justify-content: space-between;
    display: flex;
    height: 60px;
    line-height: 60px;
    font-size: 20px;
    margin-bottom: 20px;
    @include set_theme_color(background-color, item-active-bg-color);
  }
  .template-item {
    margin-bottom: 20px;
  }
  .card-list {
    padding: 10px 0;
    height: 100%;
  }
  .image-item {
    height: 148px;
    width: 148px;
    border-radius: 6px;
    overflow: hidden;
    position: relative;

    .image-file {
      width: 100%;
      height: 100%;
      border-radius: 6px;
    }

    .delete-icon {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 6px;
      display: flex;
      opacity: 0;
      justify-content: center;
      align-items: center;
      background-color: rgba($color: #000000, $alpha: 0.4);
      border: 1px solid #999999;
      transition: opacity 0.2s;

      .el-icon-delete {
        cursor: pointer;
        color: #ffffff;
        font-size: 18px;
      }
    }

    &:hover {
      .delete-icon {
        opacity: 1;
      }
    }
  }
}
</style>
